import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_active_inventory_transformations_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[] }): 
  Promise<{ result: { total_active_transformations?: number } }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_active_inventory_transformations_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id?: number, project_id?: number, warehouse_ids?: number[]    }) {
      return false;
    }
}
